import { ZCDCard, ZCDVerticalBarChart } from '@zencity/common-ui';
import { ZCDBarChartDataset } from '@zencity/common-ui/lib/ZCD/ZCDCharts/types';
import { ZCDVerticalBarChartJSOptions } from '@zencity/common-ui/lib/ZCD/ZCDCharts/ZCDVerticalBarChart/ZCDVerticalBarChart';
import { LoaderMask } from 'components/LoaderMask/LoaderMask';
import React, { ReactElement, useEffect, useState } from 'react';
import { logger } from 'utils/logger';
import { ReportBuilderWidgetProps } from 'screens/WidgetGenerator/reportGeneratorComponents/types';
import { ClassificationTopConcernsByAreaHeader } from 'screens/WidgetGenerator/reportGeneratorComponents/components/ClassificationTopConcernsByAreaHOC/ClassificationTopConcernsByAreaHeader';
import { prepareDataset } from 'screens/WidgetGenerator/reportGeneratorComponents/components/ClassificationTopConcernsByAreaHOC/ClassificationTopConcernsByAreaHOC.helpers';
import { useAnswerClassificationSubTopicBreakdown } from 'screens/WidgetGenerator/reportGeneratorComponents/hooks/useAnswerClassificationSubTopicBreakdown';
import styles from './ClassificationTopConcernsByAreaHOC.module.scss';

export const ClassificationTopConcernsByAreaHOC = (props: ReportBuilderWidgetProps): ReactElement => {
  const { params, clientData } = props;
  const { filters } = params;
  const selectedQuestionId = filters?.classifiedOpenEndedGenericQuestion;

  const [chartDataset, setChartDataset] = useState<ZCDBarChartDataset[]>([]);

  const { fetchedData, isLoading, error } = useAnswerClassificationSubTopicBreakdown({
    filters,
    clientData,
  });

  useEffect(() => {
    if (!fetchedData) {
      return;
    }

    setChartDataset(prepareDataset(fetchedData, filters?.overrideColorsMapping));
  }, [fetchedData, filters?.overrideColorsMapping]);

  if (error) {
    logger.error(error);
  }
  const options = {
    skipNull: true,
    barThickness: 12,
    borderWidth: 3,
    borderColor: 'transparent',
    scales: {
      y: {
        ticks: {
          padding: 20,
        },
      },
    },
    tooltips: { enabled: false },
    hover: { mode: undefined },
  } as ZCDVerticalBarChartJSOptions;

  return (
    <LoaderMask isLoading={isLoading}>
      <div className={styles.cardWrapper}>
        <ZCDCard header={<ClassificationTopConcernsByAreaHeader />}>
          {!selectedQuestionId && <h3>Please select a question</h3>}
          {selectedQuestionId && (
            <ZCDVerticalBarChart
              usePercentage={false}
              chartDatasets={chartDataset}
              isResponsive={false}
              maintainAspectRatio={false}
              chartOptions={options}
            />
          )}
        </ZCDCard>
      </div>
    </LoaderMask>
  );
};
